import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/arrowUp.svg';

import styles from './ArrowUpIcon.styles';

type ArrowUpIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'ArrowUpIcon' });

export default function ArrowUpIcon({ className }: ArrowUpIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.icon, className)}>
      <Icon />
    </span>
  );
}
